import type { Environment } from "../../types";
import { SsmValueCell } from "./SsmValueCell";

interface ParamEntry {
  type: string;
  value: string;
}

function ssmConsoleUrl(solution: string, env: string, component: string, param: string): string {
  const base = "https://eu-central-1.console.aws.amazon.com/systems-manager/parameters/%252Fdighum";
  const segments = [solution, env, component].map((s) => `%252F${s}`).join("");
  return `${base}${segments}%252F${encodeURIComponent(param)}/description?region=eu-central-1&tab=Table`;
}

export function ParamGroup({
  solution,
  env,
  component,
  params,
}: {
  solution: string;
  env: Environment;
  component: string;
  params: Record<string, ParamEntry>;
}) {
  const sortedKeys = Object.keys(params).sort();
  return (
    <fieldset>
      <legend>
        <strong>{component}</strong>
      </legend>
      <table class="ssm-params-table">
        <thead>
          <tr>
            <th>Parameter</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {sortedKeys.map((key) => {
            const entry = params[key];
            const isSecure = entry.type === "SecureString";
            return (
              <tr key={key} class={isSecure ? "secure-string" : ""}>
                <td>
                  <a href={ssmConsoleUrl(solution, env, component, key)} target="_blank" rel="noreferrer">
                    {key}
                  </a>
                </td>
                <td class="ssm-value-cell">
                  <SsmValueCell type={entry.type} value={entry.value} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </fieldset>
  );
}
